import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Nav,
  Breadcrumb,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactExport from "react-export-excel";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import SidebarDashboard from "../../../components/SidebarDashboard";
import {
  deleteGeneralInfo,
  editGeneralInfo,
  getDescriptorManual,
  getGeneralInfo,
  saveGeneralInfo,
} from "../../../redux/descriptorsProfiles/GeneralInfo/actions";
import LinkDescargaDescriptor from "../../../components/descriptorsProfiles/LinkDescargaDescriptor";

const DescriptorSelection = (props) => {
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const filters = [
    { id: "nombre_posicion", desc: "Descriptor" },
    { id: "descripcion", desc: "Descripción" },
    { id: "posicion_id", desc: "Función" },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  // const [tipoBusqueda, setTipoBusqueda] = useState({
  //   id: "nombre",
  //   desc: "Descriptor",
  // });

  const dispatch = useDispatch();
  const history = useHistory();

  const schema = Yup.object().shape({
    nombre_posicion: Yup.string()
      .required("**Campo requerido")
      .matches(
        /^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$/,
        "**Solo admite letras,numeros y los siguientes caracteres @$¿?!¡/-_%#."
      ),
  });

  const {
    loading,
    saveLoading,
    generalInfosLength,
    generalInfos,
    generalInfoError,
    formError,
    loadingDescriptionManual,
    docDescriptor,
  } = useSelector((store) => store.generalInfo);
  const pages = Math.ceil(generalInfosLength / limit);

  const columns = [
    {
      Header: "Descriptor",
      accessor: "nombre_posicion",
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      // Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Editar descriptor</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Eliminar descriptor</Tooltip>}
          >
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={
              <Tooltip {...props}>Editar información del descriptor</Tooltip>
            }
          >
            <Button
              size="sm"
              className="text-primary"
              variant="link"
              type="button"
              onClick={() =>
                history.push(
                  `/descriptores-perfiles/descriptor/${value.row.original.id}/${value.row.original.nombre_posicion}/${props.match.params.id}/${props.match.params.nombreFuncion}`
                )
              }
            >
              <i className="material-icons">description</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Descargar descriptor</Tooltip>}
          >
            <LinkDescargaDescriptor
              id={value.row.original.id}
              nombre_posicion={value.row.original.nombre_posicion}
            />
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  // Métodos
  const _getGeneralInfo = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getGeneralInfo({
        offset: offs,
        limit: lim,
        tipo_busqueda: "posicion_id",
        filter: props.match.params.id,
        filter_nombre: filt,
      })
    );

  useEffect(() => {
    _getGeneralInfo();
  }, []);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getGeneralInfo(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    const _req = {
      nombre_posicion: req.nombre_posicion,
      posicion: parseInt(props.match.params.id),
    };
    if (!edit) {
      dispatch(saveGeneralInfo(_req, setShowModal));
    } else {
      dispatch(editGeneralInfo(_req, editItem.id, index, setShowModal));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getGeneralInfo(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteGeneralInfo(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="mb-4 px-2">
            <div className="d-flex flex-wrap justify-content-start align-items-center">
              <Button
                onClick={() =>
                  history.push(`/descriptores-perfiles/menu-usuario`)
                }
                variant="link"
                className="font-weight-bold mr-4 text-dark"
              >
                <i className="material-icons">arrow_back</i>
              </Button>
              <Breadcrumb className="pb-0">
                <Breadcrumb.Item
                  title
                  onClick={() =>
                    history.push(`/descriptores-perfiles/menu-usuario`)
                  }
                  className="text-uppercase"
                >
                  MANUAL DE PUESTOS Y FUNCIONES
                </Breadcrumb.Item>
                <Breadcrumb.Item className="text-uppercase" active title>
                  {props.match.params.nombreFuncion.replaceAll("-", "/")}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <hr />
          </div>
          <div className="my-1 pl-md-4 pr-md-3 px-2 d-flex flex-wrap justify-content-between align-items-center">
            <Row className="justify-content-end align-items-center flex-nowrap">
              <h6 className="font-weight-bold text-uppercase">
                Descriptor de la función
              </h6>
              <Col xs="auto">
                <Button
                  variant="primary"
                  size="sm"
                  className="rounded-pill"
                  onClick={() => onAdd()}
                >
                  <i className="material-icons">add</i> Crear nuevo
                </Button>
              </Col>
            </Row>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                {/* <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col> */}
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    {/* <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="primary"
                          className="btn-sm font"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger> */}
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            generalInfosLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={generalInfos} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={generalInfosLength}
                  pages={pages}
                  pagFunc={_getGeneralInfo}
                />
              </>
            )
          )}
          {!loading && generalInfosLength === 0 && generalInfoError === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience agregando algunos
            </Alert>
          )}
          {!!generalInfoError && (
            <Alert variant="danger" className="mt-4 mb-1">
              {generalInfoError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre_posicion: edit ? editItem.nombre_posicion : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar descriptor" : "Crear descriptor"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Descriptor
                  </Form.Label>
                  <Form.Control
                    id="nombre_posicion"
                    name="nombre_posicion"
                    isInvalid={
                      touched.nombre_posicion && errors.nombre_posicion
                    }
                    isValid={touched.nombre_posicion && !errors.nombre_posicion}
                    onBlur={handleBlur("nombre_posicion")}
                    onChange={handleChange}
                    value={values.nombre_posicion}
                    className="rounded-pill"
                    type="text"
                    placeholder="Descripción"
                  ></Form.Control>
                  {touched.nombre_posicion && errors.nombre_posicion && (
                    <div>
                      <small className="text-danger">
                        {errors.nombre_posicion}
                      </small>
                    </div>
                  )}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default DescriptorSelection;
